<template>
    <div>
        <div class="pop_open ms-2" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'info'" />
            </div>
        </div>

        <CommonCustomModal v-model="flagShowModal" :size="'lg'">
			<div class="row">
				<div class="col-md-12 col-12 mb-5">
					<h3 class="mb-0 font-active">Back Type</h3>
				</div>

				<div class="col-md-6 col-12 text-center">
					<img class="mx-auto" width="400" height="400" src="https://assets.friendlydiamonds.com/fdl/fd_gif/push_video.gif">
					<h5 class="text-center mb-2 font-active">Push Back</h5>
					<p class="text-center">Push backs are often most commonly used with stud earrings. The earring back pushes straight right through the post of the earring making it very easy to use. It has a snug fit and it ensures your earrings stay in place.</p>
				</div>

				<div class="col-md-6 col-12 text-center">
					<img class="mx-auto" width="400" height="400" src="https://assets.friendlydiamonds.com/fdl/fd_gif/screw_video.gif">
					<h5 class="text-center mb-2 font-active">Screw Back</h5>
					<p class="text-center">Screw backs have a kind of winding groove on the post of the earring. One can twist the back around the post in multiple circular notions to tighten or loosen the earrings. This makes it difficult for the back to fall off on its own making it a more secure option.</p> 
				</div>
			</div>
        </CommonCustomModal>
    </div>
</template>

<script setup>
	const flagShowModal = ref(false)
	function showModal(){
		flagShowModal.value = true
	}
</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
    }

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.modal-content{
    padding: 16px;
}
span{
    padding: 1%;
    color: #ccc;
    font-size: 14px;
    
}
  .gemo_box{
      cursor: pointer;
  }
  .title_block{
    /* display: flex;
    align-items: flex-start;
    justify-content: space-between; */
    text-align: right;
  }
  .modal-body {
    padding: 0 12px;
  }
  p {
    font-size: 16px;
    margin-bottom: 0;
    padding-top: 9px;
    color: #606060;
    font-weight: 400
}
  .title_block span {
      cursor: pointer;
  }
   h3{
      font-size: 24px;
      text-align: center;
      color: #212529;
  }

  h5 {
    color: #212529;
  }
  .drop_hint{
    cursor: pointer;
  }
  @media(max-width: 767px){
    h5{
        font-size: 16px;
    }
    p {
      font-size: 14px;
    }
  }
</style>
